export default __webpack_public_path__ + "static/media/Flag_of_France.svg.7a0b7aea.webp";